document.addEventListener("DOMContentLoaded", (event) => {

  const openFilter = ()=> {
    document.querySelector('body').classList.add('filter-open');
  }

  const closeFilter = ()=> {
    document.querySelector('body').classList.remove('filter-open');
  }

  const filter_allBtn = document.querySelector('.filter-all-btn');
  if(filter_allBtn){
    filter_allBtn.addEventListener('click', ()=>{
        openFilter();
    });
  }

  const filter_clear = document.querySelector('.collection__filter-bottom .active__filters__clear');

  if(filter_clear){
    filter_clear.addEventListener('click', ()=>{
      closeFilter();
    });
  }
  
  const close_filter = document.querySelector('.cf-close');
  if(close_filter){
    close_filter.addEventListener('click', ()=>{
      closeFilter();
    });
  }
  
  const apply_filter = document.querySelector('.filter-apply-btn');

  if(apply_filter){
    apply_filter.addEventListener('click', ()=>{
        closeFilter();
    });
  }

  
  const sort_btn = document.querySelector('.filter-sort-btn');
  if(sort_btn){
    sort_btn.addEventListener('click', ()=>{
      document.querySelector('body').classList.add('sort-filter-open');
      document.querySelector('body').classList.add('sort-filter-index');
    });
  }

  
  document.querySelector('.collection-sort-item .sort-close')?.addEventListener('click', ()=>{
    document.querySelector('body').classList.remove('sort-filter-open');
    setTimeout(()=>{
      document.querySelector('body').classList.remove('sort-filter-index');
    },300)
  });

  document.querySelector('.sort-apply-btn a')?.addEventListener('click', ()=>{
    document.querySelector('body').classList.remove('sort-filter-open');
    setTimeout(()=>{
      document.querySelector('body').classList.remove('sort-filter-index');
    },300)
  });

  document.querySelector('.collection__sort-bottom .active__filters__clear')?.addEventListener('click', ()=>{
    setTimeout(()=>{
      document.querySelector('body').classList.remove('sort-filter-open');  
    },500);
    setTimeout(()=>{
      document.querySelector('body').classList.remove('sort-filter-index');
    },800)
  });

  document.addEventListener('click', function(event) {
    // Check if the clicked target is NOT inside the .collection__filters or the .filter-btn.filter-all-btn
    if (!event.target.closest('.collection__filters') && !event.target.closest('.filter-btn.filter-all-btn')) {
       document.body.classList.remove('filter-open');
    }

    if (!event.target.closest('.collection-sort-item') && !event.target.closest('.filter-btn.filter-sort-btn')) {
       document.querySelector('body').classList.remove('sort-filter-open');
        setTimeout(()=>{
          document.querySelector('body').classList.remove('sort-filter-index');
        },300)
    }

    
  });

  


  
  const closeElement = document.querySelector('.cf-close');

  if(closeElement) {
    let startY = 0;

    // Listen for when the drag starts
    closeElement.addEventListener('dragstart', function(event) {
        startY = event.clientY;
      console.log('startY', startY);// Get the initial Y position when dragging starts
    });

    // Listen for dragging event
    closeElement.addEventListener('drag', function(event) {
        if (event.clientY === 0) return; // Ignore when not dragging
        const currentY = event.clientY;
        console.log('currentY', currentY);
        // Check if dragging downwards
        if (currentY > startY) {
            document.body.classList.remove('filter-open');
        }
    });

  }
  

  if(document.querySelectorAll('.collection-dec-rte .readmore-btn span').length > 0){
    document.querySelector('.collection-dec-rte .readmore-btn span').addEventListener('click', (e) => {
      const collectionDesc = e.target.closest('.collection-dec-rte');
  
      collectionDesc.querySelector('.short-dec-block').classList.toggle('dec-disable');
      collectionDesc.querySelector('.full-dec-block').classList.toggle('dec-active');
      
      e.target.innerText = e.target.innerText.trim() === 'Read more' ? 'Read less' : 'Read more';
    });
  }

  if(document.querySelectorAll('.collection-seo-content .readmore-btn span').length > 0){
    document.querySelector('.collection-seo-content .readmore-btn span').addEventListener('click', (e) => {
      const collectionDesc = e.target.closest('.collection-seo-content');
  
      collectionDesc.querySelector('.short-seo-text').classList.toggle('dec-disable');
      collectionDesc.querySelector('.full-seo-text').classList.toggle('dec-active');
      
      e.target.innerText = e.target.innerText.trim() === 'Read more' ? 'Read less' : 'Read more';
    });
  }

  // faq accodion

  function Listeners() {
    this.entries = [];
    console.log('this.entries', this.entries)
  }

  Listeners.prototype.add = function (element, event, fn) {
    this.entries.push({element: element, event: event, fn: fn});
    element.addEventListener(event, fn);
  };

  Listeners.prototype.removeAll = function () {
    this.entries = this.entries.filter(function (listener) {
      listener.element.removeEventListener(listener.event, listener.fn);
      return false;
    });
  };

  const selectors$faq = {
    faqTrigger: '[data-faq-trigger]',
    faqContent: '[data-faq-content]',
  };

  const classes$faq = {
    isExpanded: 'is-expanded',
  };

  const sections$5 = {};

  class FAQCollapsible {
    constructor(el) {
        this.section = el;
        this.triggers = this.section.querySelectorAll(selectors$faq.faqTrigger);
        this._listeners = new Listeners();
        this.init();
    }

    init() {
        this.triggers.forEach((trigger) => {
            this._listeners.add(trigger, 'click', (event) => this.toggleFAQ(event, trigger));
        });
    }

    toggleFAQ(event, trigger) {
        event.preventDefault();
        const faqId = trigger.getAttribute('aria-controls');
        const faqContent = document.getElementById(faqId);
        const parent = trigger.parentNode;
        const isExpanded = parent.classList.contains(classes$faq.isExpanded);

        trigger.setAttribute('aria-expanded', !isExpanded);
        parent.classList.toggle(classes$faq.isExpanded, !isExpanded);

        faqContent.style.maxHeight = isExpanded ? '0px' : `${faqContent.scrollHeight}px`;
    }

    onUnload() {
        this._listeners.removeAll();
    }
  }
  
  const faqCollapsible = {
    onLoad() {
        sections$5[this.id] = new FAQCollapsible(this.container);
    },
    onUnload(e) {
        sections$5[this.id].onUnload(e);
    },
  };

   document.querySelectorAll("[data-faq-section]").forEach((section) => {
        new FAQCollapsible(section);
  });
  
  
});  